var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('task-details-item',{attrs:{"title":"tasks.details.status"}},[_c('template',{slot:"icon"},[_c('plus-square-icon',{attrs:{"size":"20"}})],1),_vm._v("\n  "+_vm._s(_vm.status)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }